import { map } from 'lodash';

import {
  fetchMember,
  selectMember,
  selectMemberLevel,
  selectSubscription,
  selectPrintTooltip,
} from 'logic/member';

import {
  fetchMealPlan,
  selectMealPlan,
  selectMealPlanPdfs,
  selectShoppingListRecipes,
} from 'logic/mealPlan';

import {
  shoppingListFetch,
  shoppingListToggleCheck,
  shoppingListUncheckAll,
  selectShoppingList,
  selectShoppingListChecked,
  selectShoppingListHasChecked,
  selectShoppingListIsLoading,
  selectShoppingListMeta,
} from 'logic/shoppingList';

export const ShoppingList = {
  template: `
    <section class="shopping-list pt-3 pb-5 bg-gray-100 border border-y">
      <div class="container pb-3">
        <div class="row">
          <div class="col-md-5 order-2 order-md-1">
            <span class="d-table-cell text-nowrap pr-2">
              Group By:
            </span>
            <div class="d-table-cell w-100">
              <div class="pill-toggle d-flex">
                <button
                  type="button"
                  class="btn btn-sm btn-pill w-100"
                  ng-class="{ 'btn-primary': $ctrl.sort === 'category' }"
                  ng-click="$ctrl.onToggle('category')">
                  Category
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-pill w-100"
                  ng-class="{ 'btn-primary': $ctrl.sort === 'recipe' }"
                  ng-click="$ctrl.onToggle('recipe')">
                  Recipes
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-7 order-1 order-md-2">
            <div class="d-flex align-items-center pb-3 pb-md-0"
              ng-class="{
                'justify-content-between': $ctrl.hasChecked,
                'justify-content-end': !$ctrl.hasChecked
              }">
              <button-link
                ng-show="$ctrl.hasChecked"
                ng-click="$ctrl.shoppingListUncheckAll($ctrl.member.id)">
                <span class="font-size-small font-size-md-base">
                  Reset Shopping List
                </span>
              </button-link>
              <button-print
                uri="{{ $ctrl.pdfs.shoppingList }}?level={{ $ctrl.level }}&group_by={{ $ctrl.sort }}"
                tooltip="$ctrl.tooltip"
                ng-click="$ctrl.refetchMember()"
                ng-if="$ctrl.subscription.canPrint">
              </button-print>
            </div>
          </div>
        </div>
        <div class="pt-4"
          ng-repeat="(name, ingredients) in $ctrl.shoppingList track by $index"
          ng-hide="$ctrl.isLoading || ingredients.length === 0">
          <h4>
            <span class="mr-2">
              {{ name }}
            </span>
            <span class="text-gray"
              ng-if="$ctrl.sort === 'recipe' && $ctrl.recipes">
              <i class="icon-serves text-green-dark"></i>
              x{{ $ctrl.shoppingListMeta[name].serves }}
            </span>
          </h4>
          <div class="py-3 bg-white border border-y">
            <strong class="ml-4"
              ng-if="$ctrl.sort === 'recipe' && $ctrl.shoppingListMeta[name].count > 1">
              Appears {{ $ctrl.shoppingListMeta[name].count }}x, ingredients adjusted.
            </strong>
            <ingredients-checklist
              ingredients="ingredients"
              checked="$ctrl.checked"
              on-toggle="$ctrl.shoppingListToggleCheck(item, $ctrl.member.id)">
            </ingredients-checklist>
          </div>
        </div>
      </div>
    </section>`,

  controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.mealPlan.id) {
          this.fetchMealPlan(this.mealPlanId, this.level);
        }

        this.recipes.length ? this.onToggle('category') : this.onLoaded();
      },

      $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },

      onLoaded() {
        this.unsubscribe = $ngRedux.subscribe(() => {
          if (this.recipes.length) {
            this.unsubscribe();
            this.onToggle('category');
          }
        });
      },

      onToggle(sort) {
        this.sort = sort;
        this.shoppingListFetch(
          map(this.recipes, 'id').join(),
          this.member.id,
          sort,
          this.level
        );
      },

      refetchMember() {
        this.tooltip && $timeout(() => this.fetchMember(this.member.id), 500);
      },

      mapState({ mealPlan, member, router, shoppingList }) {
        const { mealPlanId } = router.currentParams;
        const subscription = selectSubscription(member);
        const recipes = selectShoppingListRecipes(mealPlan, mealPlanId);

        return {
          mealPlanId,
          recipes,
          subscription,

          // Member
          member: selectMember(member),
          level: selectMemberLevel(member),
          tooltip: selectPrintTooltip(member),

          // Meal plan
          mealPlan: selectMealPlan(mealPlan, mealPlanId),
          pdfs: selectMealPlanPdfs(mealPlan, mealPlanId, subscription.id),

          // Shoppinglist
          isLoading: selectShoppingListIsLoading(shoppingList),
          checked: selectShoppingListChecked(shoppingList),
          hasChecked: selectShoppingListHasChecked(shoppingList),
          shoppingList: selectShoppingList(shoppingList),
          shoppingListMeta: selectShoppingListMeta(shoppingList, recipes),
        };
      },

      mapDispatch() {
        return {
          fetchMealPlan,
          fetchMember,
          shoppingListFetch,
          shoppingListToggleCheck,
          shoppingListUncheckAll,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/ShoppingList.js